import { render } from "./SizeGuide.vue?vue&type=template&id=5ed34ef6&scoped=true"
import script from "./SizeGuide.vue?vue&type=script&lang=js"
export * from "./SizeGuide.vue?vue&type=script&lang=js"

import "./SizeGuide.vue?vue&type=style&index=0&id=5ed34ef6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed34ef6"]])

export default __exports__